import React from 'react';
import { Helmet } from 'react-helmet-async';
import './Home.css';
import Landing from '../../Components/landing';
import Portfolio from '../../Components/portfolio';
import Contact from '../../Components/Contact';
import Footer from '../../Components/Footer';
import Industry from '../../Components/industry';

const Home = () => {

  return (
    <div className='homeContainer'>
      <Helmet>
        <title>Business Automation Kenya | Cloud ERP & IT Solutions</title>
        <meta name="description" content="Future Kenya delivers business automation solutions in Kenya, including construction ERP systems to streamline operations, improve efficiency, and drive growth." />
        <meta property="og:title" content="Business Automation Kenya | Cloud ERP & IT Solutions" />
        <meta property="og:description" content="Future Kenya delivers business automation solutions in Kenya, including construction ERP systems to streamline operations, improve efficiency, and drive growth." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://futurekenya.com/" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Business Automation Kenya | Cloud ERP & IT Solutions" />
        <meta name="twitter:description" content="Future Kenya delivers business automation solutions in Kenya, including construction ERP systems to streamline operations, improve efficiency, and drive growth." />
        <link rel="canonical" href="https://futurekenya.com/" />
      </Helmet>
      <Landing />
      <Industry />
      <Portfolio />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;

